import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, AlertTriangle } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* 404 Icon */}
        <div className="mb-8">
          <div className="relative mx-auto w-32 h-32">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-orange-500 rounded-full opacity-20 animate-pulse"></div>
            <div className="relative bg-white rounded-full w-full h-full flex items-center justify-center shadow-xl border border-gray-100">
              <AlertTriangle className="w-16 h-16 text-gray-400" />
            </div>
          </div>
        </div>

        {/* Error Code */}
        <h1 className="text-6xl font-bold text-gray-900 mb-4">
          <span className="bg-gradient-to-r from-blue-600 to-orange-500 bg-clip-text text-transparent">
            404
          </span>
        </h1>

        {/* Error Message */}
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Page Not Found
        </h2>
        
        <p className="text-gray-600 mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back on track to explore our services.
        </p>

        {/* Action Buttons */}
        <div className="space-y-4">
          <Link 
            to="/" 
            className="inline-flex items-center justify-center w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-orange-500 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            <Home className="w-5 h-5 mr-2" />
            Back to Home
          </Link>
          
          <Link 
            to="/brand" 
            className="inline-flex items-center justify-center w-full px-6 py-3 bg-white text-gray-700 font-semibold rounded-lg border border-gray-200 shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105"
          >
            <Search className="w-5 h-5 mr-2" />
            Explore Our Brands
          </Link>
        </div>

        {/* Additional Help */}
        <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-100">
          <p className="text-sm text-blue-700">
            Need help? Contact our team at{' '}
            <a href="mailto:info@panagiaglobal.com" className="font-semibold hover:underline">
              info@panagiaglobal.com
            </a>
          </p>
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-10 left-10 w-20 h-20 bg-blue-400 rounded-full opacity-10 blur-xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-24 h-24 bg-orange-400 rounded-full opacity-10 blur-xl animate-pulse delay-1000"></div>
      </div>
    </div>
  );
} 